<template>
  <section class="layout-pt-lg layout-pb-lg" :style="{ backgroundColor: `var(--c-${vars.backgroundColor})`, color: `var(--c-${vars.textColor})` }">
    <div class="container">
      <div class="tw-text-center tw-max-w-4xl tw-mx-auto">
        <!-- Title -->
        <h2 class="tw-tracking-wider tw-mb-12" :style="{ color: `var(--c-${vars.textColor})` }">
          {{ vars.titleText }}
        </h2>
        
        <!-- Description Content -->
        <div class="tw-mb-12">
          <p 
            v-for="(description, index) in descriptions" 
            :key="index"
            class="tw-leading-relaxed tw-mb-6"
            :style="{ color: `var(--c-${vars.textColor})` }"
          >
            {{ description.description }}
          </p>
        </div>
        
        <!-- Author Name -->
        <div class="tw-tracking-wide tw-font-bold">
          {{ vars.authorText }}
        </div>
      </div>
    </div>
  </section>
</template>


<script lang="ts">
import { defineNuxtComponent } from '#app';
import { ComponentMixin } from '~/mixins/component.mixin';


export default defineNuxtComponent({
  name: 'Feedback',

  mixins: [ComponentMixin],

  computed: {
    descriptions() {
      return this.groupedVariables?.descriptions || [];
    },
  },
});
</script>